export default __webpack_public_path__ + "static/media/DamasoNo12.56b4f20d.jpg";